import { cn } from '@commenda/utils';
import React from 'react';

import { Icons } from '../../Icons';
import { TruncatedText } from '../../TruncatedText';

export interface DataGridCellFolderProps {
  children: React.ReactNode;
  isOpen?: boolean;
  leading?: React.ReactNode;
  className?: string;
}

const DataGridCellFolder = ({
  children,
  isOpen = false,
  leading,
  className,
}: DataGridCellFolderProps) => (
  <div className={cn('flex w-full items-center gap-lg', className)}>
    {leading}
    <span
      className="flex shrink-0 items-center"
      data-state={isOpen ? 'open' : 'closed'}
    >
      <Icons.Folder className="size-6 text-fg-quaternary" />
    </span>
    <TruncatedText className="txt-small-regular text-text-primary">
      {children}
    </TruncatedText>
  </div>
);

export { DataGridCellFolder };
